import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VerificacionRutValidator } from 'src/app/directives/verifica-rut.directive';
import { CertificadoDigital } from 'src/app/models/CertificadoDigital/CertificadoDigital';
import { Emisor } from 'src/app/models/Emisor/Emisor';
import { CertificadosDigitalesService } from 'src/app/services/certificados-digitales.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PermissionService } from 'src/app/services/permission.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { Permission } from 'src/app/shared/models/Permission';
import Swal from 'sweetalert2';
import { MantenedorBaseComponent } from '../../layout/layout-mantenedor/mantenedor-base/mantenedor-base.component';
import { catchError, delay, filter, first, last, map, retryWhen, switchMap, take, takeWhile, tap} from "rxjs/operators";
import { ConfigCertificados } from './config-certificados';
import * as FileSaver from 'file-saver';
import { EmisorService } from 'src/app/services/emisor.service';
import { title } from 'process';
import { CertificadoDigitalFilter } from 'src/app/models/CertificadoDigital/CertificadoDigitalFilter';
import { Page } from 'src/app/shared/models/Page';
import { PagedResponse } from 'src/app/shared/models/PagedResponse';
import * as moment from 'moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CertificadoFileObject } from 'src/app/models/CertificadoDigital/CertificadoFileObject';
import { SortType } from '@swimlane/ngx-datatable';
import { ChangeCompanyService } from 'src/app/services/changecompany.service';
import { VerificacionCertificadoService } from 'src/app/services/verificacion-certificado.service';
import { CertificadoDigitalRequest } from 'src/app/models/CertificadoDigital/CertificadoDigitalRequest';
import { OrigenCertificadoEnum } from 'src/app/models/CertificadoDigital/OrigenCertificadoEnum';
import { CERT_PRECIOS } from 'src/app/components/configuracion-dte/mantenedor-certificados/config-certificados';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { finalize } from 'rxjs/operators';
import { RevocacionRequest } from "src/app/models/CertificadoDigital/RevocacionRequest";
import { CertificadoFormComponent } from'src/app/components/layout/certificado-form/certificado-form.component';
import { Response } from "src/app/shared/models/Response";
import { interval, Observable, of,Subscription } from "rxjs";
import { CertificadoRequest } from 'src/app/models/Emisor/EmisorWizardRequest';
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
  selector: 'app-mantenedor-certificados',
  templateUrl: './mantenedor-certificados.component.html',
  styleUrls: ['./mantenedor-certificados.component.scss'],
})
export class MantenedorCertificadosComponent implements OnInit {
  SortType = SortType;
  math = Math;
  public sessionEmisorId: string = ''; 
  public sessionEmisor: Emisor;
  public rutEmisor: number;
  private filter: CertificadoDigitalFilter = new CertificadoDigitalFilter();
  public rowsMantenedor: CertificadoDigital[] = [];
  public page: Page = new Page();
  public certificateForm: FormGroup;
  public emisoresSource: Emisor[];
  public certificadosPermissions: Permission[] = [
    this.permissions.getPermission('20-20'),
    this.permissions.getPermission('20-20-10'),
    this.permissions.getPermission('20-20-12'),
    this.permissions.getPermission('20-20-14'),
  ];
  public componentStarted: boolean = false;
  defaultFilterCriteria = { criterio: 'Certificado', busqueda: '' };
  configLocal = ConfigCertificados;
  formCriteriaCertificados;
  objetoCertificado: CertificadoDigital = new CertificadoDigital();
  certificadoFastSearchCriteria = [
    { key: 'rut' },
    { key: 'friendlyName' },
    { key: 'fechaSubida' },
    { key: 'fechaVenc' },
  ];
  @ViewChild('renewCertificateModal') renewCertificateModalRef: any;
  @ViewChild('reposicionCertModal') reposicionCertModal: TemplateRef<any>;
  public reposicionTarifas: { [anio: number]: { reposicion: number } } = {};

  public modalRefReposicion: NgbModalRef;
  public modalReposicionData: {
    anios: 1 | 2 | 3;
    precios: { [anio: number]: { reposicion: number } };
    seleccionado: number;
    request: CertificadoRequest;
    certificado: CertificadoDigital;
    nombre: string;
    rut: string;
    correo: string;
    fechaVenc: Date | string;
  } = null;
  public certificateToRevoke: CertificadoDigital;
  public revokeForm!: FormGroup;
  public revokeFiles: File[] = [];
  filesError = '';
  empresasSource: Emisor[];
  sourceForSelectInputs: Array<any> = [];
  columnsToRender: Array<any>;
  public today: number = Date.now();
  public loading: boolean = false;
  public files: File[] = [];
  public superAdm = false;
  public createPlantillaModalRef: NgbModalRef;
  @ViewChild('tableMobile') tableRef: any;
  public compraCertificadoWizard = false;
  private emisorDefaults: Partial<CertificadoDigitalRequest> = {};

  constructor(
    public certificadosService: CertificadosDigitalesService,
    private tokenService: TokenStorageService,
    private localStorage: LocalStorageService,
    public permissions: PermissionService,
    private changeCompanyService: ChangeCompanyService,
    private validadorCertificadoService: VerificacionCertificadoService,
    public utilities: UtilitiesService,
    private emisorService: EmisorService,
    private ref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private sessionUserService: SessionUserService
  ) {
    this.superAdm = this.tokenService.getUser().superAdmin;
    this.sessionEmisorId = this.tokenService.getCompany();
    this.rutEmisor = this.tokenService.getCompanyRut();
    this.emisoresSource = JSON.parse(
      this.localStorage.getEmisores()
    ) as Emisor[];
    this.sessionEmisor = this.emisoresSource.find(
      (emisor) => emisor.emisorId == this.sessionEmisorId
    );
    if (this.superAdm) {
      this.getEmisoresFullList();
    }
    this.filter.activo = true;
    this.filter.emisorId = this.sessionEmisorId;
    this.filter.EmisorRut = this.rutEmisor;
    this.createForm();
  }

  ngOnInit(): void {
    this.sessionUserService.verificarSesionUsuario();
    this.cargarTarifasReposicion();
    this.setPage({ offset: 0 });
  }
  cargarTarifasReposicion() {
    this.certificadosService.getTarifasCertificado().subscribe({
      next: (tarifas) => {
        [1, 2, 3].forEach(anio => {
          const found = tarifas.find(
            t => t.nombreProducto.toLowerCase()  == "reposición de certificado" && t.anios === anio
          );
          this.reposicionTarifas[anio] = { reposicion: found ? found.precio : 0 };
        });
        this.ref.detectChanges();
      },
      error: () => {
        this.reposicionTarifas = { 1: { reposicion: 0 }, 2: { reposicion: 0 }, 3: { reposicion: 0 } };
      }
    });
  }

  openCertificateDigitalModal(isRenovar: boolean, row?: CertificadoDigital): void {
    const referenciaCertificadoForm   = this.modalService.open(CertificadoFormComponent, { size:'lg', scrollable: false, centered: true, windowClass: 'modal-sin-scroll'});
    const formularioCertificado = referenciaCertificadoForm.componentInstance as CertificadoFormComponent;
    formularioCertificado.mode = isRenovar ? 'renovar' : 'comprar';
    
    formularioCertificado.rutEmisor = this.rutEmisor;
    if (isRenovar && row) {
      formularioCertificado.defaults = {
        rut: row.rutFormateado
      };
    }
  
    formularioCertificado.submitted.subscribe(({ payload, total,stopLoading, closeModal }) => {
        this.loading = true;
        const Certificadoid = isRenovar ? row!.certificadoDigitalId : null;
        this.certificadosService.initTransbank(payload, Certificadoid, this.sessionEmisorId).subscribe({
          next: (res: any) => {
            this.loading = false;
            if (res.urlPago && res.tokenTransbank) {
              this.mostrarVentanaWebPay(res.urlPago, res.tokenTransbank);
              this.pollPaymentStatus(res.tokenTransbank).subscribe((paymentCompleted) => {
								stopLoading();
                closeModal();
								this.ref.detectChanges();
								if (paymentCompleted) {
									Swal.fire('Proceso iniciado correctamente', 'Nota: Si no ha finalizado el proceso de pago, no debe cerrar la ventana de WebPay, de lo contrario no se generará el certificado.', 'success')
								  .then((result) => {
										 if (result.isConfirmed || 
                        result.dismiss === Swal.DismissReason.backdrop || 
                        result.dismiss === Swal.DismissReason.esc || 
                        result.dismiss === Swal.DismissReason.timer) {
                        window.location.reload();
                    }
									});
								} else {
                  Swal.fire('Pago en verificación', "No obtuvimos respuesta del pago. Si se efectuó será procesado en breves minutos.", 'warning')
									.then((result) => {
										if (result.isConfirmed || 
                        result.dismiss === Swal.DismissReason.backdrop || 
                        result.dismiss === Swal.DismissReason.esc || 
                        result.dismiss === Swal.DismissReason.timer) {
                        window.location.reload();
                    }
									});
								}
							});
            }
          },
          error: err => {
            this.loading = false;
            stopLoading(); 
            Swal.fire('Error', err.error.message, 'error');
            this.ref.detectChanges();
          }
        });
    });
  }
  mostrarVentanaWebPay(url: string, token: string) {
      const form = document.createElement("form");
      form.method = "POST";
      form.target = "_blank";
      form.action = url;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "token_ws";
      input.value = token;
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      form.remove();
  }
  private pollPaymentStatus(token: string, maxAttempts: number = 15, pollingInterval: number = 3000): Observable<boolean> {
  let completed = false;
  let attempts = 0;
  return of(null).pipe(
    delay(30000),
    switchMap(() => {
      return interval(pollingInterval).pipe(
        takeWhile(() => !completed && attempts < maxAttempts),
        switchMap(() => {
          attempts++;
          return this.emisorService.verifyTransbank(token);
        }),
        map((response: Response<boolean>) => {
          return response.data;
        }),
        tap((success: boolean) => {
          if (success) {
            completed = true;
            this.loading = false;
          }
        }),
        last(),
        catchError((error) => {
          return of(false);
        })
      )
    })
  );
}

  shouldShowRenewButton(row: CertificadoDigital): boolean {
    const iguales = this.rowsMantenedor.filter(c =>
      c.rutFormateado === row.rutFormateado &&
      c.emisorRut === row.emisorRut &&
      c.emisorId === row.emisorId
    );
    const hayVigente = iguales.some(c =>
      c.estadoNombre === 'Vigente' && c.certificadoDigitalId !== row.certificadoDigitalId
    );

    return row.mesesRestantes <= 1 && !hayVigente;
  }

  
  closeRenewModal() {
    this.modalService.dismissAll();
  }

  setPageSize() {
    //this.page.currentPageSize = this.page.page
    this.setPage({ offset: 0 });
  }
  toggleExpandRow(row) {
    this.tableRef.rowDetail.toggleExpandRow(row);
  }
  setPage(pageInfo) {
    this.loading = true;
    this.page.pageNumber = pageInfo.offset;
    let localPage = JSON.parse(JSON.stringify(this.page));
    localPage.pageNumber += 1;
    this.certificadosService
      .getDataByPage(this.filter, localPage)
      .subscribe(
        (result) => {
          this.loading = false;
          let rows = result.data as CertificadoDigital[];
          this.rowsMantenedor = [...rows];
          var today = moment();
          this.rowsMantenedor.forEach((row) => {
            row.mesesRestantes = today.diff(row.fechaVenc, 'months') * -1;
          });
          this.setPageFromResponse(this.page, result);
          this.ref.detectChanges();
        },
        (error) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
            icon: 'error',
            title: 'Error en Lista de Certificados',
            text:
              'No fue posible obtener la lista de certificados disponibles, recargue la pagina.' +
              this.utilities.setErrorMessageFromArray(error.error),
          });
        }
      )
      .add(() => (this.componentStarted = true));
  }
  setPageFromResponse(
    currentPage: Page,
    data: PagedResponse<CertificadoDigital>
  ) {
    currentPage.pageSize = data.pageSize;
    currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
    currentPage.totalPages = data.totalPages;
    currentPage.totalElements = data.totalRecords;
  }

  popupCenter(url, title, w, h) {
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `
scrollbars=yes,
width=${w / systemZoom}, 
height=${h / systemZoom}, 
top=${top}, 
left=${left}
`
    );
    if (window.focus) {
      newWindow.focus();
    }
  }
  searchElementsByFilter(event) {
    this.filter.rut =
      event.criterio == 'rut' ? (event.busqueda ? event.busqueda : '') : '';
    this.filter.nombre =
      event.criterio == 'nombre' ? (event.busqueda ? event.busqueda : '') : '';
    this.filter.activo = event.registroActivo ? false : true;
    this.filter.emisorId =
      event.emisorId == null ? this.sessionEmisorId : event.emisorId;
    this.filter.EmisorRut = event.emisorRut;
    this.setPage({ offset: 0 });
  }
  calcRemainingDays(fechaVencimiento: string): number {
    let fechaVenc = Date.parse(fechaVencimiento);
    let diff: number = fechaVenc.valueOf() - this.today;
    let diffDays: number = Math.ceil(diff / (1000 * 3600 * 24));
    return diffDays > 0 ? diffDays : 0;
  }
 CertificateDownloadRequest(event: CertificadoDigital) {
    if (!event.garantia && event.origenCertificadoId != 4) {
      const anios = moment(event.fechaVenc).startOf('day').diff(moment(event.fechaSubida).startOf('day'), 'years') as 1 | 2 | 3;
      const precios = this.reposicionTarifas;
      const base = precios[anios]?.reposicion ?? 0;
      const iva = Math.round(base * 0.19);
      const precioConIva = base + iva;
      const request = new CertificadoRequest();
      request.NombreEmpresa = event.nombre;
      request.Rut = event.rutFormateado;
      request.Correo = event.correo;
      request.fechaExp = event.fechaVenc;
      request.neto = base;
      request.iva = iva;
      request.total = precioConIva;

      this.modalReposicionData = {
        anios: anios,
        precios: precios,
        seleccionado: anios,
        request: request,
        certificado: event,
        nombre: event.nombre,
        rut: event.rutFormateado,
        correo: event.correo,
        fechaVenc: event.fechaVenc,

      };
      this.modalRefReposicion = this.modalService.open(this.reposicionCertModal, { centered: true, size: 'md' });
      return;
    }
    this.downloadCertificate(event);
  }
  confirmarReposicion() {
    const data = this.modalReposicionData;
    this.loading = true;
    this.certificadosService.initTransbankReposicion(
      data.certificado.certificadoDigitalId,
      this.sessionEmisorId,
      data.request
    ).subscribe({
      next: (res: any) => {
        if (res.urlPago && res.tokenTransbank) {
          this.mostrarVentanaWebPay(res.urlPago, res.tokenTransbank);
          this.pollPaymentStatus(res.tokenTransbank).subscribe((paymentCompleted) => {
            this.ref.detectChanges();
            if (paymentCompleted) {
              this.loading = false;
              this.modalRefReposicion.close();
              Swal.fire('Operación exitosa', res.message, 'success')
                .then((result) => {
                  if (result.isConfirmed ||
                      result.dismiss === Swal.DismissReason.backdrop ||
                      result.dismiss === Swal.DismissReason.esc ||
                      result.dismiss === Swal.DismissReason.timer) {
                    window.location.reload();
                  }
                });
            } else {
              this.loading = false;
              this.modalRefReposicion.close();
              Swal.fire('Pago en verificación', "No obtuvimos respuesta del pago. Si se efectuó será procesado en breves minutos.", 'warning')
                .then((result) => {
                  if (result.isConfirmed ||
                      result.dismiss === Swal.DismissReason.backdrop ||
                      result.dismiss === Swal.DismissReason.esc ||
                      result.dismiss === Swal.DismissReason.timer) {
                    window.location.reload();
                  }
                });
            }
          });
        }
        this.ref.detectChanges();
      },
      error: err => {
        this.loading = false;
        this.modalRefReposicion.close();
        Swal.fire('Error', err.error.message, 'error');
        this.ref.detectChanges();
      }
    });
  }

  downloadCertificate(event: CertificadoDigital) {
    this.certificadosService.downloadCertificateRequest(event).subscribe(
      (res) => {
        this.loading = true;
        let b64Response = res.data;
        const BlobPfx = this.utilities.convertB64ToBlob(
          b64Response,
          'application/x-pkcs12'
        );
        FileSaver.saveAs(BlobPfx, 'Certificado ' + event.rutFormateado + '.pfx');
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.log(error);
        Swal.fire({
          icon: 'error',
          title: 'Error en descarga',
          text:
            'No fue posible descargar el certificado, intente nuevamente. ' +
            this.utilities.setErrorMessageFromArray(error.error),
        });
      }
    );
  }
  getEmisoresFullList() {
    this.emisorService.getData().subscribe(
      (result) => {
        let emisores = result.data;
        this.emisoresSource = emisores;
        this.ref.detectChanges();
      },
      (error) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'error',
          title: 'Error en emisores',
          text:
            'No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas.' +
            this.utilities.setErrorMessageFromArray(error.error),
        });
      }
    );
  }

  activateCertificate(row: CertificadoDigital) {
    this.loading = true;
    this.certificadosService.reactivateCertificate(row).subscribe(
      (result) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'success',
          title: 'Certificado Activado',
          text: 'El certificado fue activado',
        });
        this.setPage({ offset: 0 });
      },
      (error) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'error',
          title: 'Error al reactivar',
          text:
            'Ocurrió un error al intentar reactivar el certificado seleccionado, intente nuevamente. ' +
            this.utilities.setErrorMessageFromArray(error.error),
        });
      }
    );
  }

  deactivateCertificate(event: CertificadoDigital) {
    this.loading = true;
    this.certificadosService.deactivateCertificate(event).subscribe(
      (result) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'success',
          title: 'Certificado Desactivado',
          text: 'El certificado fue desactivado',
        });
        this.setPage({ offset: 0 });
      },
      (error) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'error',
          title: 'Error al desactivar',
          text:
            'Ocurrió un error al intentar desactivar el certificado seleccionado, intente nuevamente. ' +
            this.utilities.setErrorMessageFromArray(error.error),
        });
      }
    );
  }

  deleteCertificate(event: CertificadoDigital) {
    this.loading = true;
    this.certificadosService.delete(event).subscribe(
      (result) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'success',
          title: 'Certificado Eliminado',
          text: 'El certificado fue eliminado',
        });
        this.setPage({ offset: 0 });
      },
      (error) => {
        this.loading = false;
        this.ref.detectChanges();
        Swal.fire({
          icon: 'error',
          title: 'Error al Eliminar',
          text:
            'Ocurrió un error al intentar eliminar el certificado seleccionado, intente nuevamente. ' +
            this.utilities.setErrorMessageFromArray(error.error),
        });
      }
    );
  }

  openCreateCertificateModal(modalRef) {
    this.createForm();
    this.files = [];
    this.createPlantillaModalRef = this.modalService.open(modalRef, {
      windowClass: '',
      size: 'lg',
    });
  }
  closeCreateCertificateModal() {
    this.createPlantillaModalRef.close();
  }
  createForm() {
    this.certificateForm = this.formBuilder.group({
      password: [, Validators.required],
      rutString: [, [Validators.required, VerificacionRutValidator]],
      emisor: [this.sessionEmisor, Validators.required],
      file: [, Validators.required],
    });
  }

  onFileChangeCER(event) {
    if (event.rejectedFiles[0] || this.getName(event) != 'pfx') {
      Swal.fire({
        icon: 'error',
        title: 'Error de Archivo',
        text:
          'El archivo ingresado no es de formato pfx, favor agregar un archivo con el formato correcto. Razón: ' +
            event.rejectedFiles[0].reason ==
          'size'
            ? 'Tamaño'
            : 'Tipo de archivo',
      });
    } else {
      this.files.push(...event.addedFiles);
      if (this.files.length > 1) {
        this.files.shift();
      }
      this.certificateForm.controls.file.patchValue({ file: this.files[0] });
    }
  }
  getName(event): string {
    if (event.addedFiles) {
      return event.addedFiles[0].name.split('.').pop();
    } else if (event.rejectedFiles) {
      return event.rejectedFiles[0].name.split('.').pop();
    } else {
      return '';
    }
  }

  onRemoveCertificaddoArray(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  addCertificate() {
    if (this.certificateForm.valid) {
      this.loading = true;
      var certificate = new CertificadoFileObject();
      certificate.RutFormateado = this.certificateForm.controls.rutString.value;
      certificate.password = this.certificateForm.controls.password.value;
      var issuing = this.certificateForm.controls.emisor.value as Emisor;
      certificate.emisorId = issuing.emisorId;
      certificate.file = this.files[0];
      this.certificadosService.addCertificate(certificate).subscribe(
        (res) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
            icon: 'success',
            title: 'Certificado Guardado',
            text: 'El certificado fue guardado correctamente',
          });
          this.closeCreateCertificateModal();
          this.setPage({ offset: 0 });
        },
        (err) => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
            icon: 'error',
            title: 'Error al Guardar',
            text:
              'Ocurrió un error al intentar guardar el certificado digital, intente nuevamente. ' +
              this.utilities.setErrorMessageFromArray(err.error),
          });
        }
      );
    }
  }
  openRevokeModal(modalRef: TemplateRef<any>, cert: CertificadoDigital) {
    this.certificateToRevoke = cert;   
    this.initRevokeForm(cert);
    this.modalService.open(modalRef, { size: 'lg', centered: true });
  }
  private initRevokeForm(cert: CertificadoDigital) {
    this.revokeForm = this.formBuilder.group({
      nombre:       [cert.nombre || '', Validators.required],
      rut:          [cert.rutFormateado,        Validators.required],
      correo:       ['', [Validators.required, Validators.email]],
      telefono:     [''],
      comentarios:  [''],
      confirmado:   [false, Validators.requiredTrue]
    });
    this.revokeFiles = [];
    this.filesError  = '';
  }
  
  onFilesAdded(ev: NgxDropzoneChangeEvent) {
    if (this.revokeFiles.length + ev.addedFiles.length > 5) {
      this.filesError = `Máx. 5 archivos permitidos`;
      return;
    }
    this.revokeFiles.push(...ev.addedFiles);
    this.filesError = '';
  }
  
  onRemoveFile(file: File) {
    this.revokeFiles = this.revokeFiles.filter(f => f !== file);
    this.filesError  = '';
  }
  
  confirmRevoke() {
    if (this.revokeForm.invalid || !this.revokeFiles.length) {
      this.filesError = 'Debe adjuntar al menos un archivo';
      return;
    }
    const dto: RevocacionRequest = {
      certificadoId:     this.certificateToRevoke.certificadoDigitalId,
      NombreCompleto:    this.revokeForm.value.nombre,
      Rut:               this.revokeForm.value.rut,
      CorreoContacto:    this.revokeForm.value.correo,
      TelefonoContacto:  this.revokeForm.value.telefono || undefined,
      Comentarios:       this.revokeForm.value.comentarios || undefined,
      Archivos:          this.revokeFiles
    };    
    this.loading = true;
    this.certificadosService.revocar(dto)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        res => {
          this.loading = false;
          this.ref.detectChanges();
          if (res.data) {
            Swal.fire({
              icon: 'success',
              title: 'Solicitud enviada',
              text: 'Tu petición de revocación ha sido registrada correctamente.'
            });
            this.closeRevokeModal();
            this.setPage({ offset: 0 });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'No se pudo enviar',
              text: res.message
            });
          }
        },
        err => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al enviar la solicitud: ' + err.error?.message
          });
        }
      );
  }
  downloadCartaRevocacion() {
    const id = this.certificateToRevoke.certificadoDigitalId;
    this.loading = true;
    this.certificadosService
      .downloadRevocationLetter(id)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: blob => {
          this.loading = false;
          this.ref.detectChanges();
          const filename = `CartaRevocacion_${this.certificateToRevoke.rutFormateado}.docx`;
          FileSaver.saveAs(blob, filename);
        },
        error: () => {
          this.loading = false;
          this.ref.detectChanges();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No fue posible descargar la carta de revocación.'
          });
        }
      });
  }
  closeRevokeModal() {
    this.modalService.dismissAll();
  }

}
